import React from "react";
import PropTypes from "prop-types";
import AdminRoutes from "../routes/AdminRoutes";
import ConsumerRoutes from "../routes/ConsumerRoutes";

const App = ({ cableApp }) => {
  return window.location.host.split(".")[0] === "admin" ? (
    <AdminRoutes cableApp={cableApp} />
  ) : (
    <ConsumerRoutes cableApp={cableApp} />
  );
};

App.propTypes = {
  cableApp: PropTypes.object.isRequired,
};

export default App;
